import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { ConversationSortOrder } from "@next-platform/packages-ts-types";
import React, { useMemo } from "react";

import ChatsSortDropdown from "@/components/Chats/ChatsSortDropdown";
import Trans from "@/components/Trans/Trans";

type ChatsListToolbarProps = {
  visibleCount: number;
  sortOrder: ConversationSortOrder;
  onSortChange: (sortOrder: ConversationSortOrder) => void;
  "data-testid"?: string;
};

const ChatsListToolbar = ({ visibleCount, sortOrder, onSortChange, "data-testid": testId = "ChatsListToolbar" }: ChatsListToolbarProps) => {
  const conversationCountValues = useMemo(() => ({ count: visibleCount }), [visibleCount]);

  return (
    <div className="flex items-center justify-between mb-md" data-testid={testId}>
      <Text data-testid="ChatsListToolbar-Count" variant={TextVariants.PARAGRAPH_XSMALL_REGULAR} className="text-gray-11">
        <Trans i18nKey="chats:page.common.conversationCount" values={conversationCountValues} />
      </Text>
      <ChatsSortDropdown value={sortOrder} onChange={onSortChange} />
    </div>
  );
};

export default React.memo(ChatsListToolbar);
